export default __webpack_public_path__ + "static/lwiedmann-bd1c9777355ca487c977e7296615a9d6.png";